// extracted by mini-css-extract-plugin
export default {"attached":"styles_attached__vufr4","winnerSegment":"styles_winnerSegment__G480i","subHeader":"styles_subHeader__NUh6a"};